/**
 * Intro Animation
 * Shows black screen with "MICHAEL HUBBARD" text sliding in from left
 * Only shows on first visit or manual refresh, not on navigation
 */

(function() {
  'use strict';

  // Only run on homepage (index page)
  if (window.location.pathname !== '/' && !window.location.pathname.match(/^\/\?/)) {
    return;
  }

  // Detect navigation type - simple and clean
  function getNavigationType() {
    if (performance.getEntriesByType) {
      const navEntries = performance.getEntriesByType('navigation');
      if (navEntries.length > 0) {
        return navEntries[0].type; // 'navigate', 'reload', 'back_forward'
      }
    }
    if (performance.navigation) {
      const type = performance.navigation.type;
      if (type === 1) return 'reload'; // Manual refresh
      if (type === 2) return 'back_forward'; // Back/forward button
      return 'navigate'; // Clicked link, typed URL
    }
    return 'navigate';
  }

  // Check if animation should be shown
  const navType = getNavigationType();
  const hasSeenIntroInSession = sessionStorage.getItem('intro-animation-shown');
  
  // Show animation ONLY if:
  // 1. Manual refresh (reload), OR
  // 2. First visit (navigate) AND hasn't been shown in this session
  // Do NOT show on back_forward navigation or if already shown
  const shouldShowAnimation = (navType === 'reload') || (navType === 'navigate' && !hasSeenIntroInSession);

  // If it's a manual refresh, scroll to top immediately so animation aligns properly
  if (navType === 'reload') {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  if (!shouldShowAnimation) {
    // If animation shouldn't show, immediately hide the overlay element
    const immediateOverlay = document.getElementById('intro-overlay-immediate');
    if (immediateOverlay) {
      immediateOverlay.remove();
    }
    document.body.classList.add('intro-animation-complete');
    return;
  }

  function initIntroAnimation() {
    // Wait for header to be fully rendered so we can get its exact position
    const getHeaderPosition = () => {
      // Get the actual text element - this is the span with the text
      const headerText = document.querySelector('.header__site-name');
      
      if (!headerText) {
        return null;
      }
      
      // Get the exact bounding rectangle of the text element
      const rect = headerText.getBoundingClientRect();
      const computedStyle = window.getComputedStyle(headerText);
      
      // Calculate exact top position from viewport top
      // Since overlay is position: fixed, use viewport-relative position (rect.top)
      // NOT absolute position (rect.top + scrollY)
      const exactTop = rect.top;
      
      console.log('Header position detected:', {
        top: exactTop,
        viewportTop: rect.top,
        scrollY: window.scrollY,
        height: rect.height,
        width: rect.width,
        lineHeight: computedStyle.lineHeight,
        fontSize: computedStyle.fontSize,
        paddingLeft: computedStyle.paddingLeft,
        paddingRight: computedStyle.paddingRight
      });
      
      return {
        top: exactTop,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        // Store computed styles for exact matching
        lineHeight: computedStyle.lineHeight,
        fontSize: computedStyle.fontSize,
        fontFamily: computedStyle.fontFamily,
        fontWeight: computedStyle.fontWeight,
        letterSpacing: computedStyle.letterSpacing,
        paddingLeft: computedStyle.paddingLeft,
        paddingRight: computedStyle.paddingRight,
        paddingTop: computedStyle.paddingTop,
        paddingBottom: computedStyle.paddingBottom,
        marginTop: computedStyle.marginTop,
        marginBottom: computedStyle.marginBottom,
        marginLeft: computedStyle.marginLeft,
        marginRight: computedStyle.marginRight
      };
    };

    // Wait for page to be fully loaded and rendered
    // Use multiple strategies to ensure header is ready
    const waitForHeader = () => {
      let headerPos = getHeaderPosition();
      let retries = 0;
      const maxRetries = 20; // Increased retries
      
      const checkHeader = setInterval(() => {
        headerPos = getHeaderPosition();
        retries++;
        
        // Check if we have a valid position with actual dimensions
        if (headerPos && headerPos.height > 0 && headerPos.width > 0) {
          clearInterval(checkHeader);
          createAnimation(headerPos);
        } else if (retries >= maxRetries) {
          clearInterval(checkHeader);
          // Fallback to default position if header not found
          console.warn('Header not found, using fallback position');
          headerPos = { top: 90, left: 0, width: 0, height: 0 };
          createAnimation(headerPos);
        }
      }, 100); // Check every 100ms
    };

    // Wait for both DOM and window load
    if (document.readyState === 'complete') {
      // Page already loaded, wait a bit for rendering
      setTimeout(waitForHeader, 100);
    } else {
      window.addEventListener('load', () => {
        setTimeout(waitForHeader, 100);
      });
    }
  }

  function createAnimation(headerPos) {
    // Hide body overflow during animation
    document.body.style.overflow = 'hidden';
    
    // Remove the immediate overlay (it will be replaced by JavaScript overlay)
    const immediateOverlay = document.getElementById('intro-overlay-immediate');
    if (immediateOverlay) {
      immediateOverlay.remove();
    }
    
    // Create overlay element
    const overlay = document.createElement('div');
    overlay.className = 'intro-overlay';
    overlay.id = 'intro-overlay';

    // Create text element
    const text = document.createElement('div');
    text.className = 'intro-text';
    text.textContent = 'MICHAEL HUBBARD';
    
    // Position text to match header EXACTLY
    // Use the exact top position from getBoundingClientRect (viewport-relative for fixed positioning)
    text.style.top = headerPos.top + 'px';
    text.style.left = '50%';
    text.style.transform = 'translateX(-50%) translateX(-100vw)'; // Start off-screen
    
    // Match ALL styling properties exactly from the real header
    const headerElement = document.querySelector('.header__site-name');
    if (headerElement) {
      const computedStyle = window.getComputedStyle(headerElement);
      
      // Match all text properties exactly
      text.style.lineHeight = computedStyle.lineHeight;
      text.style.fontSize = computedStyle.fontSize;
      text.style.fontFamily = computedStyle.fontFamily;
      text.style.fontWeight = computedStyle.fontWeight;
      text.style.letterSpacing = computedStyle.letterSpacing;
      text.style.textTransform = computedStyle.textTransform;
      
      // Match padding properties for text alignment (but not width constraints)
      text.style.paddingLeft = computedStyle.paddingLeft;
      text.style.paddingRight = computedStyle.paddingRight;
      text.style.paddingTop = computedStyle.paddingTop;
      text.style.paddingBottom = computedStyle.paddingBottom;
      
      // Match margin top/bottom for vertical alignment
      text.style.marginTop = computedStyle.marginTop;
      text.style.marginBottom = computedStyle.marginBottom;
      
      // Reset horizontal margins to allow proper centering
      text.style.marginLeft = '0';
      text.style.marginRight = '0';
      
      // Match display but NOT width/maxWidth - let text center naturally
      text.style.display = computedStyle.display;
      text.style.verticalAlign = computedStyle.verticalAlign || 'baseline';
      text.style.boxSizing = computedStyle.boxSizing;
      // DO NOT copy width or maxWidth - let text be its natural width for centering
      
      console.log('Matched styles:', {
        lineHeight: computedStyle.lineHeight,
        fontSize: computedStyle.fontSize,
        top: headerPos.top,
        paddingLeft: computedStyle.paddingLeft,
        paddingRight: computedStyle.paddingRight,
        width: computedStyle.width,
        maxWidth: computedStyle.maxWidth
      });
    }

    overlay.appendChild(text);
    document.body.appendChild(overlay);

    // Force a reflow to ensure initial state is applied
    void overlay.offsetHeight;

    // Start the slide-in animation
    setTimeout(() => {
      text.classList.add('sliding-in');
      // Update transform to slide to center (matching header position)
      text.style.transform = 'translateX(-50%) translateX(0)';
    }, 100); // Small delay to ensure CSS is applied

    // Wait for slide animation to complete (3 seconds) + 1.3 seconds pause, then fade out
    const slideDuration = 3000; // 3 seconds for slide animation
    const pauseDuration = 1300; // 1.3 seconds pause after slide completes
    const totalWaitTime = slideDuration + pauseDuration; // 4.3 seconds total

    setTimeout(() => {
      // Start fade-out
      overlay.classList.add('hiding');
      
      // Remove overlay completely after fade-out transition completes
      setTimeout(() => {
        overlay.classList.add('hidden');
        overlay.remove(); // Remove from DOM
        // Mark animation as complete
        document.body.classList.add('intro-animation-complete');
        // Restore body overflow
        document.body.style.overflow = '';
      }, 1300); // Match the fade-out transition duration (1.3s)
    }, totalWaitTime); // Wait for slide (3s) + pause (1.3s) = 4.3s before fading
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIntroAnimation);
  } else {
    initIntroAnimation();
  }

  // Mark as shown in this session
  sessionStorage.setItem('intro-animation-shown', 'true');
})();

